import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "truncate" }

import { computed, withDefaults } from "vue"
import { XIcon } from "@heroicons/vue/solid"
import { getInitials } from "@/shared/utils/helpers"

interface Props {
    isRemovable?: boolean
    bgColor?: string
    textColor?: string
    smallPadding?: boolean
    hasAvatar?: boolean
    fullName?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsChip',
  props: {
    isRemovable: { type: Boolean, default: true },
    bgColor: { default: "#F3F4F6" },
    textColor: { default: "#282B34" },
    smallPadding: { type: Boolean, default: false },
    hasAvatar: { type: Boolean, default: false },
    fullName: {}
  },
  emits: ["onRemove"],
  setup(__props: any) {

const props = __props

const styleClasses = computed(() => [
    props.smallPadding ? "p-0.5 pe-2" : "py-1 px-2.5",
    "inline-flex items-center rounded-full text-xs font-medium",
])

function getColorStyle() {
    return {
        backgroundColor: props.bgColor,
        color: props.textColor,
    }
}



return (_ctx: any,_cache: any) => {
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([styleClasses.value, _ctx.bgColor === '#FFFFFF' ? 'border rounded-full border-gray-300' : '']),
    style: _normalizeStyle(getColorStyle())
  }, [
    (props.hasAvatar)
      ? (_openBlock(), _createBlock(_component_Avatar, {
          key: 0,
          label: _unref(getInitials)(_ctx.fullName),
          shape: "circle",
          class: "h-4 w-4 text-[8px] mr-1"
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (props.isRemovable)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "flex-shrink-0 ml-1 h-4 w-4 rounded-full inline-flex items-center justify-center focus:outline-none bg-transparent",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('onRemove')), ["prevent","stop"]))
        }, [
          _createVNode(_unref(XIcon), {
            class: _normalizeClass(["h-3 w-3", `text-[${props.textColor}]`]),
            "aria-hidden": "true"
          }, null, 8, ["class"])
        ]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})